import type { GlobalContext } from './types'

export const UNKNOWN_VERSION = 'unknown'

const isValidVersionString = (version: string) =>
  /^\d+\.\d+\.\d+$/.test(version)

const parseAppUrl = (url: string) => {
  const split = url.split('/')
  const possibleArtifact = split[split.length - 3]
  const possibleVersion = split[split.length - 2]
  if (!isValidVersionString(possibleVersion)) {
    throw new Error(`Invalid version string ${possibleVersion}`)
  }
  return {
    appName: possibleArtifact,
    version: possibleVersion,
  }
}

export const getAppNameWithVersion = (url: string) => {
  try {
    const { appName, version } = parseAppUrl(url)
    return `${appName}@${version}`
  } catch {
    return UNKNOWN_VERSION
  }
}

export const getAppVersion = (url: string) => {
  try {
    const { version } = parseAppUrl(url)
    return version
  } catch {
    return UNKNOWN_VERSION
  }
}

export const getAppUrlFromGlobalContext = (globalContext: GlobalContext) =>
  (globalContext as any).staticsUrl || globalContext.location.href

const getStackTrace = () => {
  const dummyError = new Error()
  return dummyError.stack ? dummyError.stack.toString() : ''
}

export const getAppUrl = (appName: string) => {
  const urlMatches = getStackTrace().match(
    new RegExp(`https?://.*?${appName}.*?.js`),
  )
  return urlMatches ? urlMatches[0] : ''
}

export const isLocalhost = () => /https?:\/\/localhost/.test(getStackTrace())
